/** Short course-path titles; frozen Chinese source titles remain unchanged. */
export const HSK2_LESSON_TITLES = [
  'Поездка в Пекин', 'Распорядок дня', 'Который из них мой?', 'Как я нашёл работу',
  'Выбираем одежду', 'За столом', 'Далеко ли до работы?', 'Дайте подумать',
  'Ещё не закончил', 'Где мой телефон?', 'Сравниваем возраст', 'Одежда по погоде',
  'Открытая дверь', 'Ты смотрел этот фильм?', 'Скоро Новый год',
] as const;
